module.exports = __webpack_public_path__ + "media/images/icons/youtube-color-c0a2f5f50d843ecc76673765fd4ddbf0.svg";